/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LabsList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  TestName?: string | null;
  pageNumber?: number;
  sortbydirection?: string | null;
}

export function labsList(http: HttpClient, rootUrl: string, params?: LabsList$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, labsList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('TestName', params.TestName, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

labsList.PATH = '/lab/list';
